import React from "react";
import styled, { keyframes, useTheme } from "styled-components";

const Wrapper = styled.div`
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	padding: 20px;
	gap: 10px;
	transition: all 0.33s cubic-bezier(0.165, 0.84, 0.44, 1);

	min-height: 276px;
	height: 276px;
	max-height: 276px;

	min-width: 420px;
	width: 420px;
	max-width: 420px;
`;

const loading = keyframes`
	0%{
        background-position: 1000px 0
    }
    100%{
        background-position: -1000px 0
    }
`;

const AnimatedBg = styled.div`
	animation-duration: 2.25s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: ${loading};
	animation-timing-function: linear;
	background: darkgray;
	background: linear-gradient(
		70deg,
		rgba(255, 255, 255, 0) 20%,
		rgba(255, 255, 255, 0.5) 36%,
		rgba(255, 255, 255, 0) 52%
	);
	background-size: 1000px;
	height: 100%;
	width: 100%;
	position: relative;
`;

const ProductImage = styled.div`
	position: relative;
	min-height: 100%;
	height: 100%;
	max-height: 100%;
	width: 100%;
	background-color: ${props => props.theme.Gray1};
`;

const ProductInformation = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const NameLabel = styled.div`
	height: 18px;
	width: 70%;
	background-color: ${props => props.theme.Gray1};
`;

export const CategoryCardPlaceholder = () => {

	return (
		<Wrapper>
			<ProductImage>
				<AnimatedBg />
			</ProductImage>
			{/*<ProductInformation>
				<NameLabel>
					<AnimatedBg />
				</NameLabel>
			</ProductInformation>*/}
		</Wrapper>
	);
};
